<template>
        <div v-if="!isLoading && !isDismissed">
            <div v-if="BadgeAlert.data" class="alert alert-block alert-info alert-badge">
                <span class="fa fa-times-circle fa-2x close-btn" @click="dismissBadgeAlert(BadgeAlert.data.id)">
                </span>
                    <div class="row">
                    <div class="col-xs-2 col-md-2 no-padding-bottom no-margin-bottom">
                        <span class="badge-with-points" :style="{backgroundImage:'url('+absolutePath(currentBadge.img_name_blank)+')'}">
                                <span class="badge-points"> {{ positifFormating(BadgeAlert.data.nbr_points) }}</span>
                        </span>
                    </div>
                    <div class="col-xs-10 col-md-10 no-padding-bottom no-margin-bottom">
                        <div class=" align-content-center break-word">
                            <span>
                                <RouterLink to="badges" class="">
                                    <strong>
                                        <span v-if="BadgeAlert.data.nbr_points<0">{{ 'You lose'|trans}}</span>
                                        <span v-else>{{ 'You earn'|trans}}</span>
                                        {{BadgeAlert.data.nbr_points}}
                                        <span v-if="BadgeAlert.data.nbr_points>1">{{'points'|trans}}</span>
                                        <span v-else>{{'point'|trans}} </span>
                                         {{'for'|trans}} : {{ BadgeAlert.data.reason|trans }}
                                    </strong>
                                </RouterLink>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
	import badgesCollection from "../../Badges/badges_collection";

	/**
     * Will be used when there is a new point added to this worker
	 */
	export default {
		data(){
			return {
				isLoading:false,
				BadgeAlert:null,
				badges: badgesCollection,
                currentBadge:null,
				isDismissed: false
			}
		},
        async created() {
            await this.getBadgeAlert();
		},
		methods:{
			async getBadgeAlert(){
				this.isLoading = true;
				this.BadgeAlert = await this.$api.worker.getBadgeAlert();
				this.currentBadge = this.getCurrentBadge();
				this.isLoading = false;
            },
			async dismissBadgeAlert(workerBadgePointId){
				await this.$api.worker.dismissBadgeAlert(workerBadgePointId);
				this.isDismissed = true;
			},
			absolutePath(image) {
				return process.env.VUE_APP_API_BASE_URL_ASSETS + "/images/badges/" + image;
			},
			getCurrentBadge() {
				return this.badges.find((element) => {
					if(this.BadgeAlert.badgeId === null ){
						return element.badge_id === this.BadgeAlert.badgeId;
					}
					return element.badge_id === parseInt(this.BadgeAlert.badgeId);
				});
			},
			positifFormating(value){
				if(value > 0){
					return '+'+value;
				}
				return value;
			}
        }
    }
</script>

<style scoped>
    .title-message-open-alert {
        white-space: nowrap;
    }

    .badge-with-points{
        width: 40px;
        height: 42px;
        background-size: 40px;
        float:left;
        text-align: center;
        padding:12px;
        line-height:16px;
    }
    .badge-with-points .badge-points{
        font-weight: bold;
        font-size: 14px;
    }
    .margin-text{
        font-weight: bold;
    }
    .break-word{
        word-wrap: break-word;
    }
    .align-content-center{
        display: table-cell;
        height: 40px;
        vertical-align: middle;
    }
    .align-content-center span{

    }
    .alert-badge{
        position: relative;
    }
    .close-btn{
        position: absolute;
        top: -7px;
        right: -7px;
        cursor: pointer;
    }
</style>
